module.exports = __webpack_public_path__ + "static/media/vegitables_61.b6b71ad4.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_61.csv
// module id = 648
// module chunks = 0